/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { StrategyQuoter, StrategyQuoterInterface } from '../StrategyQuoter'

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract IStrategyVault',
        name: '_strategy',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_strategyTokenAmount',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: '_recepient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_maxMarginAmount',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct IStrategyVault.StrategyTradeParams',
        name: '_tradeParams',
        type: 'tuple'
      }
    ],
    name: 'quoteDeposit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'finalDepositMargin',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class StrategyQuoter__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    _strategy: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<StrategyQuoter> {
    return super.deploy(_strategy, overrides || {}) as Promise<StrategyQuoter>
  }
  getDeployTransaction(
    _strategy: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_strategy, overrides || {})
  }
  attach(address: string): StrategyQuoter {
    return super.attach(address) as StrategyQuoter
  }
  connect(signer: Signer): StrategyQuoter__factory {
    return super.connect(signer) as StrategyQuoter__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): StrategyQuoterInterface {
    return new utils.Interface(_abi) as StrategyQuoterInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StrategyQuoter {
    return new Contract(address, _abi, signerOrProvider) as StrategyQuoter
  }
}
